'use client'

import { AlertCircle, Link } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { buttonVariants } from '@/components/ui/button-variants'
import { cn } from '@/lib/utils'

interface AppErrorFallbackProps {
  title: string
  description: string
  digest?: string
  onRetry?: () => void
}

export function AppErrorFallback({
  title,
  description,
  digest,
  onRetry,
}: AppErrorFallbackProps) {
  return (
    <div className="from-background to-muted/20 flex min-h-screen items-center justify-center bg-linear-to-br px-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <div className="bg-destructive/10 rounded-full p-3">
            <AlertCircle className="text-destructive h-8 w-8" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="font-eb-garamond text-foreground text-3xl font-light tracking-tight">
            {title}
          </h1>
          <p className="text-muted-foreground text-[0.9375rem] leading-relaxed">
            {description}
          </p>
          {digest ? (
            <p className="text-muted-foreground/80 font-mono text-xs">
              Reference {digest}
            </p>
          ) : null}
        </div>

        {onRetry ? (
          <Button type="button" onClick={onRetry}>
            Try again
          </Button>
        ) : (
          <Link href="/" className={cn(buttonVariants({ variant: 'default' }))}>
            Back home
          </Link>
        )}
      </div>
    </div>
  )
}
